module.exports = __webpack_public_path__ + "static/media/Group 3861.af4b10af.svg";